<template>
  <div class="viewcontent" v-if="translations.buttons && translations.terms">
    <div class="titlecont">
      <h2>
        Normes d'ús del portal
      </h2>
    </div>
    <div class="textcont">
      <div class="maintext">
        L’Usuari es compromet a utilitzar la Web de conformitat a la Llei i al
        present Avís Legal, així com a la moral i a les bones costums. A aquest
        efecte, l’Usuari s’abstindrà d’utilitzar la pàgina amb finalitats
        il·lícites o prohibides, lesives de drets i interessos de tercers, o que
        de qualsevol forma puguin danyar, inutilitzar, sobrecarregar, deteriorar
        o impedir la normal utilització d’equips informàtics o documents, arxius
        i tota classe de continguts emmagatzemats en qualsevol equip informàtic
        del prestador.
      </div>
      <div>
        <div class="point">
          <h4>1- Ús de la web</h4>
          <p>
            En particular, i a títol indicatiu però no exhaustiu, l’Usuari es
            compromet a no publicar, transmetre, difondre o posar a la disposició de
            tercers informacions, dades, continguts, missatges, gràfics,
            dibuixos, arxius de so o imatge, fotografies, enregistraments,
            programari i, en general, qualsevol classe de material (ja sigui en 
            forma d'esdeveniments, d'activitats o de comentaris) que:
          </p>
          <ol>
            <li>
              Sigui contrària, menyspreï o atempti contra els drets fonamentals
              i les llibertats públiques reconegudes constitucionalment, en
              tractats internacionals i altres normes vigents;
            </li>
            <li>
              Indueixi, inciti o promogui actuacions delictives, denigrants,
              difamatòries, violentes o, en general, contràries a la llei, a la
              moral i a l’ordre públic;
            </li>
            <li>
              Indueixi, inciti o promogui actuacions, actituds o pensaments
              discriminatoris per raó de sexe, raça, religió, creences, edat o
              condició;
            </li>
            <li>
              Sigui contrari al dret a l’honor, a la intimitat personal o
              familiar o a la pròpia imatge de les persones;
            </li>
            <li>
              De qualsevol manera perjudiqui la credibilitat del prestador o de
              tercers; 
            </li>
            <li>
              Constitueixi publicitat il·lícita, enganyosa o deslleial;
            </li>
            <li>
              Estigui protegit per drets d'ús o sota llicència privativa;
            </li>
            <li>
              Sigui ofensiu o inapropiat, mostrant violència tant contra les persones
              com contra animals.
            </li>
          </ol>
        </div>
        <div class="point">
          <h4>
            2- Responsabilitat
          </h4>
          <p>
            Amb els límits establerts en la llei,
            <b>FestApp.cat</b> no assumeix cap responsabilitat derivada de la
            falta de veracitat, integritat, actualització i precisió de les
            dades o informacions que es contenen en el present lloc web.
          </p>
          <p>
            En qualsevol cas, <b>FestApp.cat</b> queda exempt de responsabilitat
            derivada d’errors en els continguts que poguessin aparèixer en la
            web, sempre que no ens siguin imputables.
          </p>
          <p>
            No garantim la fiabilitat, disponibilitat o continuïtat de la web ni
            dels seus continguts per motius tècnics, de seguretat o manteniment,
            per errors del servidor que allotja els continguts o altres
            intermediaris o proveïdors.
          </p>
          <p>
            Tampoc ens fem responsables de les conseqüències, danys o perjudicis
            que puguin causar al sistema informàtic de l’usuari o als fitxers o
            documents emmagatzemats en aquest, que siguin causats o derivin de
            la capacitat o qualitat del seu sistema informàtic o de la presència
            d’un virus o una altra aplicació informàtica perjudicial a
            l’ordinador que sigui utilitzat per a la connexió als continguts de
            la pàgina web, de la qualitat de la seva connexió o accés a
            internet, per un mal funcionament del seu navegador, o per l’ús
            d’aplicacions informàtiques de versions no actualitzades.
          </p>
        </div>
        <div class="point">
          <h4>3- Mesures cautelars</h4>
          <p>
            <b>FestApp.cat</b> es reserva el dret de bloquejar comptes d'usuari,
            tant subscriptors gratuïts com usuaris de pagament, en cas
            d'incompliment de la present normativa.
          </p>
          <p>
            També es reserva el dret d'esborrar continguts sense previ avís en
            cas que aquests continguts siguin sospitosos d'incomplir-la.
          </p>
          <p>
            En cas d'incompliments greus que puguin ser constitutius de delicte
            es comunicarà a les entitats pertinents.
          </p>
        </div>
        <div class="point">
          <h4>
            4- Propietat Intel·lectual i Industrial
          </h4>
          <p>
            El lloc web, incloent a títol enunciatiu però no limitatiu la
            programació, edició, compilació i altres elements necessaris per al
            seu funcionament, els dissenys, logotips, textos, vídeos,
            fotografies i/o gràfics són propietat del prestador o, en cas que
            fos necessari, disposa de la llicència o autorització expressa per
            part dels autors.
          </p>
          <p>
            Els drets de les imatges, vídeos o continguts en general enviat pels
            subscriptors de forma voluntària, i pels usuaris a l'hora de crear
            els esdeveniments i les activitats, son cedits incondicionalment a
            <b>FestApp.cat</b> per tal de poder-los mostrar com a part dels seus
            continguts.
          </p>
          <p>
            Tots els continguts del lloc web es troben degudament protegits per
            la normativa de propietat intel·lectual i industrial.
          </p>
          <p>
            Independentment de la finalitat per la qual fossin destinats, la
            reproducció total o parcial, ús, distribució i comunicació pública
            requereixen de l’autorització escrita prèvia per part del prestador.
            Qualsevol ús no autoritzat prèviament per part del prestador serà
            considerat un incompliment greu dels drets de propietat
            intel·lectual o industrial de l’autor.
          </p>
          <p>
            Els dissenys, logotips, textos i/o gràfics aliens a
            <b>FestApp.cat</b> i que puguin aparèixer en el lloc web, pertanyen
            als seus respectius propietaris, sent ells mateixos els responsables
            de qualsevol possible controvèrsia que pogués esdevenir respecte a
            aquests. En tot cas, el <b>FestApp.cat</b> compta amb l’autorització
            expressa i prèvia per part d’aquests.
          </p>
          <p>
            <b>FestApp.cat</b> reconeix a favor dels seus titulars els
            corresponents drets de propietat industrial i intel·lectual, no
            implicant l’esment o aparició en el lloc web, de l’existència de
            drets o cap responsabilitat del prestador sobre aquests, com tampoc
            suport, patrocini o recomanació per part d’aquest.
          </p>
          <p>
            Per a realitzar qualsevol tipus d’observació respecte a possibles
            incompliments dels drets de propietat intel·lectual o industrial,
            així com sobre qualsevol dels continguts del lloc web, pot fer-lo a
            través del correu electrònic
            <a href="mailto:hola@festapp.cat" target="_blank"
              >hola@festapp.cat
            </a>
          </p>
        </div>
      </div>
    </div>

    <div class="titlecont">
      <h2>
        Política de privacitat i galetes
      </h2>
    </div>
    <div class="textcont">
      <div class="maintext">
        FestApp.cat, en consonància amb la política de protecció de dades que
        tot seguit definim, es compromet a respectar la privacitat i
        confidencialitat de les vostres dades.
        <br />
        Tota la informació que es recull a
        <a href="http://festapp.cat" target="_blank">festapp.cat</a> és tractada
        amb una absoluta i estricta confidencialitat.
      </div>

      <div class="point">
        <h4>
          1- Tractament de les dades
        </h4>
        <p>
          Només es recullen o capturen els noms, adreces de correu electrònic o
          qualsevol altre dada de caràcter personal que voluntàriament faci
          arribar l'usuari i, únicament, pels tràmits específics que així ho
          requereixin.
        </p>
        <p>
          Es garanteix la confidencialitat en el tractament de totes les dades
          de caràcter personal a les que es tingui accés com a conseqüència del
          registre a
          <a href="http://festapp.cat" target="_blank">festapp.cat</a>.
        </p>
        <p>
          Només es demanarà el registre de dades de caràcter personal quan
          aquestes siguin necessàries per la selecció d'activitats recomanades,
          o bé quan es realitzin qüestionaris per estudis demogràfics, on les
          dades recollides seran guardades de forma anònima. Les dades
          obtingudes i les que es puguin originar com a conseqüència de
          l'execució del servei resulten necessàries pel desenvolupament,
          control, gestió i execució dels tràmits sol·licitats i seran
          incorporades als fitxers adients creats.
        </p>
        <p>
          Tant els responsables dels fitxers com qui intervingui en qualsevol
          fase del tractament, estan sotmesos al més estricte secret
          professional, amb un especial compromís d'adoptar els nivells de
          protecció i les mesures necessàries, tant tècniques com
          organitzatives, per a garantir la seguretat de les dades de caràcter
          personal i evitar la seva alteració, mal ús, pèrdua, robatori,
          tractament o accés no autoritzat.
        </p>
        <p>
          Finalment, FestApp.cat garanteix que tant els fitxers i programes, com
          els equips i locals que intervenen en el procés de tractament de les
          dades registrades, compleixen els requisits d'integritat i seguretat
          establerts a la normativa vigent en cada moment.
        </p>
      </div>
      <div class="point">
        <h4>2- Deures i obligacions</h4>
        <p>
          L'usuari podrà exercitar tots els drets reconeguts per la normativa
          sobre protecció de dades de caràcter personal vigent en cada moment i,
          en especial, els drets d'accés, rectificació, cancel·lació i oposició.
        </p>
        <p>
          L'exercici d'aquests drets es podrà exercir de forma digital
          mitjançant els formularis de contacte existents a l'àrea privada dels
          usuaris o enviant un correu electrònic a
          <a href="mailto:hola@festapp.cat" target="_blank">hola@festapp.cat</a>
          .
        </p>
      </div>
      <div class="point">
        <h4>3- Cessions</h4>
        <p>
          Les dades de caràcter personal recollides com a conseqüència del
          registre a
          <a href="http://festapp.cat" target="_blank">festapp.cat</a>
          no seran facilitades o comunicades a tercers aliens a aquest servei,
          excepte de forma anonimitzada o siguin requerides per les autoritats
          públiques competents, de conformitat amb les disposicions legals i
          reglamentàries aplicables en cada moment.
        </p>
      </div>

      <div class="point">
        <h4>4- Consentiment</h4>
        <p>
          La sol·licitud de registre implicarà l'acceptació expressa i sense
          reserves de la política de privacitat de dades de caràcter personal, i
          la política de galetes aquí indicada.
        </p>
        <p>
          La introducció i registre de les dades de caràcter personal per part
          de l'usuari comportarà l'acceptació i autorització expressa a
          FestApp.cat recollida, per a la incorporació als fitxers adients i el
          tractament necessari de les dades personal, i finalment,
          l'autorització per a la seva conservació durant els terminis previstos
          a les disposicions legals aplicables.
        </p>
        <p>
          Atès que l'autorització de l'usuari al tractament i cessions indicats
          té caràcter voluntari, l'usuari podrà revocar l'autorització aquí
          concedida, tant pel tractament com per a la cessió de les dades,
          segons els termes establerts a la normativa sobre protecció de dades
          vigent en cada moment.
        </p>
      </div>
      <div class="point">
        <h4>5- Drets dels afectats</h4>
        <p>
          Els usuaris podran, en qualsevol moment, exercitar els drets
          reconeguts per la normativa de protecció de dades i, en particular,
          els drets d'accés, rectificació, cancel·lació i oposició, així com
          també el dret a revocar el consentiment prestat per a la cessió de les
          seves dades.
        </p>
        <p>
          Aquests drets poden ser exercitats tant per l'usuari com pel seu
          representant, mitjançant sol·licitud escrita i signada per escrit a la
          següent adreça de correu electrònic
          <a href="mailto:hola@festapp.cat" target="_blank">hola@festapp.cat</a
          >, on sol·licitarem la documentació pertinent per exercir el dret
          escollit.
        </p>
        <p>
          La sol·licitud haurà de contenir les següents dades: nom i cognoms de
          l'usuari, adreça, fotocòpia del DNI o passaport i contingut concret
          del dret exercitat.
        </p>
      </div>
      <div class="point">
        <h4>6- Política de galetes (cookies)</h4>
        <p>
          Les cookies són petits arxius de text que el navegador emmagatzema al
          disc dur de l'ordinador de l'usuari i que s'associen únicament amb un
          usuari anònim. No poden llegir dades del disc dur de l'usuari ni
          tampoc altres cookies dipositades per altres proveïdors a través dels
          seus espais web.
        </p>
        <p>
          El portal
          <a href="http://festapp.cat" target="_blank">festapp.cat</a>
          fa servir les cookies només per obtenir informació sobre la data i
          hora de l'últim cop que l'usuari va visitar el nostre portal i els
          continguts escollits a la seva navegació amb la finalitat de treure
          estadístiques d'ús del portal, per guardar l’idioma escollit de
          navegació i per identificar la IP de connexió per raons de seguretat i
          protecció dels comptes d'usuari.
        </p>
        <p>
          Com a mecanisme de control, l'usuari té la possibilitat de configurar
          el seu navegador per ser avisat de la recepció de cookies pel seu
          ordinador, si bé aquesta desactivació provocarà que part de la pàgina
          no pugui funcionar amb normalitat. En el cas que l’usuari vulgui
          deshabilitar les cookies ho podrà fer a través de la secció de
          preferències del seu navegador d’Internet.
        </p>
      </div>
      <div class="point">
        <h4>
          7- Legislació aplicable
        </h4>
        <p>
          La privacitat de tota la informació facilitada, tant la facilitada per
          l'usuari a través dels diferents formularis de sol·licitud de dades
          personals, com l'accessible a través de
          <a href="http://festapp.cat" target="_blank">festapp.cat</a>, estan
          regulades per la Llei Orgànica 15/99, de 13 de desembre de Protecció
          de Dades de Caràcter Personal i pels reglaments que la desenvolupen.
        </p>
      </div>
    </div>
    <div class="col-12 pt-2">
      <button class="btn btn-danger mx-2" type="button" @click="cancel()">
        {{ translations.buttons.btn_exit }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    name: 'Terms',
    computed: {
      ...mapState(['translations']),
    },
    methods: {
      ...mapActions(['changeToolSelected']),
      cancel() {
        this.changeToolSelected(null)
      },
    },
  }
</script>

<style scoped>
  h2 {
    box-sizing: border-box;
    color: inherit;
    line-height: 1.42857;
    margin: 0px;
    font-size: 19.2px;
  }
  h4 {
    font-weight: 700;
    font-size: initial;
    margin: 12px 0;
  }
  ol {
    list-style: lower-latin;
  }
  a {
    font-weight: bold;
  }
  .titlecont {
    box-sizing: border-box;
    padding: 12px;
    border-bottom: 1px solid rgb(229, 229, 229);
    min-height: 25px;
  }
  .textcont {
    box-sizing: border-box;
    padding: 12px;
    text-align: left;
  }

  .point {
    box-sizing: border-box;
    margin: 20px 0px;
  }
  .maintext {
    margin-top: 20px;
  }
</style>
